<template>
    <client-only fallback-tag="span">
        <template #fallback>
            <v-placeholder class="w-24 rounded text-base before:via-gray-200">
                .....
            </v-placeholder>
        </template>

        <v-placeholder v-if="status === 'idle' || status === 'pending'"
            class="w-24 rounded text-base before:via-gray-200">
            .....
        </v-placeholder>

        <h-popover v-else-if="status === 'success'"
            class="relative"
            @mouseover="isOpen = true"
            @mouseleave="isOpen = false"
            @focusin="isOpen = true"
            @focusout="isOpen = false">
            <h-popover-button
                class="flex flex-row items-center justify-center gap-2"
                @click="$emit('trigger')">
                <div class="flex items-center space-x-px">
                    <v-icon v-for="i in 5"
                        :key="i"
                        class="fill-[#f6ca6c] stroke-brand-black"
                        :icon="getIcon(i, rating)" />
                </div>

                <span class="text-sm text-gray-600">
                    ({{ totalRatingCount }})
                </span>
            </h-popover-button>

            <transition
                enter-active-class="transition duration-150"
                enter-from-class="opacity-0 -translate-y-2'"
                enter-to-class="opacity-100"
                leave-active-class="transition duration-150"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0 -translate-y-2'"
            >
                <h-popover-panel v-if="isOpenDebounced"
                    static
                    class="absolute left-1/2 top-full z-10 w-64 -translate-x-1/2 bg-transparent pt-3">
                    <v-page-product-rating-tooltip
                        :ratings="totalRatings"
                        :total-rating-count="totalRatingCount"
                        :skus="properties.skus"
                        @click="$emit('trigger')" />
                </h-popover-panel>
            </transition>
        </h-popover>
    </client-only>
</template>

<script setup lang="ts">
import { refDebounced } from '@vueuse/core';

const properties = defineProps<{
    skus: string[]
}>();

defineEmits<{
    (event: 'trigger'): void
}>();

const isOpen = ref(false);
const isOpenDebounced = refDebounced(isOpen, 300);

const {
    getReviews,
    getRating,
    getIcon,
} = useReviews();

const {
    status,
    totalRatings,
} = getReviews(properties.skus, 1, 'product-page-stars');

const { rating, totalRatingCount } = getRating(properties.skus);
</script>
